/* eslint-disable jira/filename-case */

import camelCase from 'lodash/camelCase';
import {
	type ProjectType,
	CORE_PROJECT,
	SOFTWARE_PROJECT,
	SERVICE_DESK_PROJECT,
} from '@jira/platform__project-types/src/project-types.tsx';

// For consistency reasons, we would like to have our analytics to be similar to T4J and use `productType` instead
// of `projectType` and to use `workManagement` instead of `business`
// https://jdog.jira-dev.com/browse/KURO-1128

export const ANALYTICS_PRODUCT_MAP: {
	[key: string]: string;
} = {
	[CORE_PROJECT]: 'workManagement',
	[SOFTWARE_PROJECT]: 'software',
	[SERVICE_DESK_PROJECT]: 'serviceManagement',
};

export const getProductType = (projectType?: ProjectType): string | null => {
	if (projectType) {
		return ANALYTICS_PRODUCT_MAP[projectType] || camelCase(projectType);
	}
	return null;
};

export const convertTaskIdToActionSubjectId = (taskId: string | null): string => {
	if (!taskId) {
		return '';
	}

	return camelCase(taskId.split('.').pop());
};
